import { setIn } from "formik";

import { FieldProps } from "types/form";

export function buildImageConstraints({
  accept,
  imageWidth,
  imageHeight,
  imageAspectRatio,
  imageSizeMib,
}: Pick<
  FieldProps,
  "accept" | "imageWidth" | "imageHeight" | "imageAspectRatio" | "imageSizeMib"
>) {
  let constraints = "";
  const formats = accept
    ?.filter((v) => !v.includes("*"))
    .map((v) => v.trim().toLowerCase())
    .map((v) => v.replace(/^image\//, ""))
    .map((v) => v.replace(/^svg\+xml$/, "svg"))
    .map((v) => (v.startsWith(".") ? v.slice(1) : v))
    .map((v) => v.toUpperCase())
    .toSorted();
  if (!accept?.includes("image/*") && formats && formats.length > 0) {
    constraints += `${formats.join("/")} format`;
  } else {
    constraints += "any format";
  }
  constraints += ", ";
  if (imageWidth !== undefined && imageHeight !== undefined) {
    if (Array.isArray(imageWidth) && Array.isArray(imageHeight)) {
      constraints += `${imageWidth[0]} x ${imageHeight[0]} - ${imageWidth[1]} x ${imageHeight[1]} px resolution`;
    } else if (Array.isArray(imageWidth) && !Array.isArray(imageHeight)) {
      constraints += `${imageWidth[0]} x ${imageHeight} - ${imageWidth[1]} x ${imageHeight} px resolution`;
    } else if (!Array.isArray(imageWidth) && Array.isArray(imageHeight)) {
      constraints += `${imageWidth} x ${imageHeight[0]} - ${imageWidth} x ${imageHeight[1]} px resolution`;
    } else {
      constraints += `${imageWidth} x ${imageHeight} px resolution`;
    }
  } else if (imageWidth !== undefined) {
    if (Array.isArray(imageWidth)) {
      constraints += `${imageWidth[0]} - ${imageWidth[1]} px width`;
    } else {
      constraints += `${imageWidth} px width`;
    }
  } else if (imageHeight !== undefined) {
    if (Array.isArray(imageHeight)) {
      constraints += `${imageHeight[0]} - ${imageHeight[1]} px height`;
    } else {
      constraints += `${imageHeight} px height`;
    }
  } else {
    constraints += "any resolution";
  }
  if (imageAspectRatio) {
    constraints += ", ";
    constraints += `${imageAspectRatio[0]}:${imageAspectRatio[1]} aspect ratio`;
  }
  if (imageSizeMib !== undefined) {
    constraints += ", ";
    constraints += `${imageSizeMib.toFixed(2)} MiB max`;
  }
  return constraints;
}

export function setUrlsInValues<T>(
  urls: { name: string; url: string }[],
  values: T
): T {
  let result = values;
  for (const { name, url } of urls) {
    result = setIn(result, name, url);
  }
  return result;
}
